// extracted by mini-css-extract-plugin
module.exports = {"modal":"jgp-312s7","iframe":"jgp-32zGI","loader":"jgp-X2_VV","modalCloseButton":"jgp-1kMiS"};